<template>
  <div class="homeContainerRefuge">
    <div class="underLogoPhrase">
      <h2 class="font-weight-bold mb-4 centers">La Boutique</h2>
      <p class="littlesize">
        Notre boutique est une source de revenus primordiale pour l'association.
        <br />
        Retrouve sur notre page Facebook nos différents articles disponibles à la vente.
      </p>
    </div>

    <div id="fb-root"></div>

    <div style="display: flex; justify-content: center;">
      <div
        class="fb-page"
        data-href="https://www.facebook.com/BricaBrac1RCF/"
        data-tabs="timeline"
        data-height="700"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-show-facepile="true"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";

function loadFacebookSDK() {
  return new Promise((resolve) => {
    if (window.FB) return resolve();
    if (document.getElementById("facebook-jssdk")) return resolve();

    window.fbAsyncInit = function () {
      window.FB.init({
        xfbml: true,
        version: "v20.0",
      });
      resolve();
    };

    const script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/fr_FR/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
  });
}

onMounted(async () => {
  await loadFacebookSDK();

  if (window.FB) {
    window.FB.XFBML.parse();
  }
});
</script>
